import { USAGE_SURFACES } from './featureEvents.js';
/**
 * The event a host answers with its surface (`detail: 'desktop'`): the desktop shell relays the host's `{"gyroSurface":"desktop"}`
 * as this DOM event, once on page load and again whenever the widget asks (the handshake of the desktop half, PR #763).
 */
export const USAGE_SURFACE_EVENT = 'gyro:surface';
/** The widget's request for it, dispatched once it listens (the shell posts `surface:ready` to its host). */
export const USAGE_SURFACE_READY_EVENT = 'gyro:surface-ready';
export function parseUsageSurface(value) {
    return typeof value === 'string' && USAGE_SURFACES.includes(value) ? value : undefined;
}
/**
 * The widget's surface: what the host said when it answered, else the desktop app's widget (app key 'desktop') is `desktop`,
 * Gyro on the web (app key 'web', a full-window pane on its own page) is `web`, the Office pane (layout 'pane') is `office`,
 * and every other page is `web`.
 */
export function usageSurfaceFor(o) {
    const host = parseUsageSurface(o.hostSurface);
    if (host)
        return host;
    if (o.appKey === 'desktop')
        return 'desktop';
    if (o.appKey === 'web')
        return 'web';
    if (o.layout === 'pane')
        return 'office';
    return 'web';
}
/** `Edge 141`, `Chrome 141`, `Firefox 140`, `Safari 18`, `Opera 120`, or `Browser` when the user agent names none of them. */
export function reducedUserAgent(userAgent) {
    const ua = typeof userAgent === 'string' ? userAgent : '';
    const named = [
        ['Edge', /\bEdg(?:e|A|iOS)?\/(\d+)/],
        ['Opera', /\bOPR\/(\d+)/],
        ['Firefox', /\bFirefox\/(\d+)/],
        ['Chrome', /\bChrome\/(\d+)/],
        ['Safari', /\bVersion\/(\d+)[^ ]* .*Safari\//],
    ];
    for (const [name, pattern] of named) {
        const match = pattern.exec(ua);
        if (match)
            return `${name} ${match[1]}`;
    }
    return 'Browser';
}
/** Phone, tablet or desktop from the user agent (and the touch points, for an iPad that calls itself a Mac). */
export function deviceClassFor(userAgent, maxTouchPoints = 0) {
    const ua = typeof userAgent === 'string' ? userAgent : '';
    if (/\biPhone\b|\biPod\b|Windows Phone|\bMobile\b/.test(ua) && !/\biPad\b/.test(ua))
        return 'phone';
    if (/\biPad\b|\bTablet\b|\bAndroid\b(?!.*\bMobile\b)/.test(ua))
        return 'tablet';
    if (/\bMacintosh\b/.test(ua) && maxTouchPoints > 1)
        return 'tablet';
    return 'desktop';
}
/** The page's own envelope values, from `navigator` (or the one handed in). */
export function clientEnvironment(nav) {
    const source = nav === undefined ? globalThis.navigator : nav;
    const ua = source?.userAgent;
    return { os_version: reducedUserAgent(ua), device_class: deviceClassFor(ua, source?.maxTouchPoints ?? 0) };
}
//# sourceMappingURL=environment.js.map